import { z } from "zod";
import type { Operation } from "../../types";

const apply: Operation<
  void,
  void,
  { version?: number },
  {
    already_applied: boolean;
    seed_version: number;
    inserted?: Record<string, number>;
  }
> = {
  method: "POST",
  path: () => "/api/crm/seed/apply",
  body: z.object({ version: z.number().int().optional() }),
  response: z.object({
    already_applied: z.boolean(),
    seed_version: z.number(),
    inserted: z.record(z.string(), z.number()).optional(),
  }),
};

export const seed = { apply };
